import { AbTestService } from 'common/service/ab-test/service';
import { FooterService } from 'common/service/footer/service';
import { HeaderService } from 'common/service/header/service';
import { LanguageSelectorService } from 'common/service/language-selector/service';
import { StatsService } from 'common/service/stats/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { UserAvatarComponent } from 'desktop/module/user/avatar/component';

AbTestService().initialize();

// Common services
HeaderService()
  .setComponents({
    UserAvatarComponent,
  })
  .render();
UserAuthenticationService();
FooterService();

LanguageSelectorService();

// Log stats (because there is no dedicated view)
StatsService().pageView();
